import React from 'react';

const RefundPolicyModal = ({ isOpen, onClose }) => {
  return (
    <div className="relative w-full h-full p-8 bg-primary">
      {/* Content */}
      <div className="max-w-5xl mx-auto relative flex">
        {/* Content */}
        <div className="w-full md:w-3/4">
          {/* FAQs Section */}
          <section className="mb-12">
            <h2 className="text-3xl custom-font-text text-center mb-8">FAQs</h2>
            <div className="space-y-6 font-semibold text-secondary">
              <div>
                <p className="font-bold custom-font-text mb-4">Do you clean your coins?</p>
                <p className="italic">No, we never clean our coins. Most of them have already been professionally cleaned prior to being sold at auction. Ancient coins should only be cleaned by a professional as rough cleaning or caustic chemicals can damage the coin and devalue it. We also recommend keeping your coins away from perfumes or scented soaps to avoid discolouration.</p>
              </div>

              <div>
                <p className="font-bold custom-font-text mb-4">Are these coins real or cast replicas of real coins?</p>
                <p className="italic">All our coins are authentic ancient coins that are sourced from reputable auction houses across North America and Europe or directly from professional numismatists or from private collections. None of our coins are cast replicas.</p>
              </div>

              <div>
                <p className="font-bold custom-font-text mb-4">Are your dark grey chains steel or sterling silver?</p>
                <p className="italic">All of our chains are made from 925 sterling silver that have been oxidised with liver of sulphur to give it an old, worn in feel. This oxidisation will wear with use to a nice, soft patina.</p>
              </div>
            </div>
          </section>

          <div className="h-0.5 my-12 w-full bg-secondary/80"></div>

          {/* Refund Policy Section */}
          <section>
            <h2 className="text-2xl custom-font-text text-center mb-8">Refund Policy</h2>
            <p className="custom-font-text text-secondary italic mb-8 text-center">
              At Circe's Forge, we are committed to ensuring that you are completely satisfied with your purchase. 
              If for any reason you are not satisfied, we are happy to offer a refund under the following terms and conditions:
            </p>

            <div className="space-y-8 text-secondary">
              <div>
                <h3 className="text-md font-semibold mb-2 custom-font-text">1. Eligibility for Refund</h3>
                <p className="mb-2 text-sm"><span className="font-bold text-sm custom-font-text">Timeframe:</span> We accept refund requests within 14 days from the date of delivery.</p>
                <p className="mb-2 text-sm"><span className="font-bold text-sm custom-font-text">Condition of the Product:</span> To be eligible for a refund, the jewellery must be in new, unused, and resalable condition. Items that have been worn, altered, resized, or damaged will not be eligible for a refund.</p>
                <p className="mb-2 text-sm"><span className="font-bold text-sm custom-font-text">Exceptions:</span> Personalized or custom-made jewellery cannot be returned or refunded unless there is a defect.</p>
              </div>

              <div className="text-sm">
                <h3 className="text-md font-bold mb-2 custom-font-text">2. Process to Request a Refund</h3>
                <p>To initiate a return, please contact us at keira@circesforge.com with your order and the reason for the return.</p>
                <p>We will guide you through the process and provide you with instructions on how to send the item back.</p>
              </div>

              <div className="text-sm">
                <h3 className="text-md font-semibold mb-2 custom-font-text">3. Contact Information</h3>
                <p>For any inquiries regarding returns or refunds, please reach out to us at: <a href="mailto:keira@circesforge.com" className="italic font-bold">keira@circesforge.com</a></p>
              </div>
            </div>
          </section>
        </div>

        {/* Circe Image */}
        <div className="md:w-1/4 md:flex hidden h-screen sticky my-auto flex items-center justify-center">
          <img 
            src={process.env.PUBLIC_URL + "/g-logo-04.png"} 
            alt="Circe Illustration" 
            className="max-w-[400%] min-w-[300%] h-auto object-contain opacity-50 -mr-64 mt-10"
          />
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyModal;